import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { X, Plus } from 'lucide-react';
import React from 'react'
import styles from '../AdminPanelPage.module.scss'

const CreateTopBaseForm = ({ modalPayload = {}, setModalPayload = () => {}, closeModal = () => {}, createTopBase, loadTopBases = async () => {}, notifySuccess = () => {}, notifyError = () => {} }) => {
  useInterfaceLanguage();
  return (
    <>
      <label>{tr("Название")}</label>
      <input placeholder={tr("Название ТОП-Базы")} value={modalPayload.name || ''} onChange={(e) => setModalPayload(p => ({ ...p, name: e.target.value }))} />
      <label>{tr("Телефон")}</label>
      <input placeholder={tr("Телефон")} value={modalPayload.phone || ''} onChange={(e) => setModalPayload(p => ({ ...p, phone: e.target.value }))} />
      <label>{tr("Геолокация (широта,долгота)")}</label>
      <input placeholder="42.8746,74.5698" value={modalPayload.geo || ''} onChange={(e) => setModalPayload(p => ({ ...p, geo: e.target.value }))} />
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => { closeModal() }} className={styles.btn_pin_close}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
        <button onClick={async () => {
          try { await createTopBase(modalPayload); await loadTopBases(); closeModal(); notifySuccess(tr("ТОП-База создана")) } catch (err) { console.error(err); notifyError(err, tr("Не удалось создать ТОП-Базу")) }
        }} className={styles.btn_pin}><Plus size={14} aria-hidden="true"/>{tr(" Создать")}</button>
      </div>
    </>
  )
}

export default CreateTopBaseForm
